import { trpc } from "@/lib/trpc";

export const useStopStreamMutation = () => {
    return trpc.stream.stopStream.useMutation();
};
